import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import styled from '@emotion/styled'
import withDeferedRender from 'util/hoc/withDeferedRender'

import {
  doUpdateReplyDraft,
  doUpdateReplyDraftDelayed,
  doUpdateAndSendReplyDraft,
  doInitializeDraft,
  selectReplyDraft,
  selectTicketDraftIsSendable,
} from 'ducks/drafts'
import { doOpenTicketPage } from 'actions/pages'
import { doRealtimeAgentStartTicketTypingNotification } from 'actions/realtime'

import { selectIsAgentColliding } from 'ducks/collisions/selectors'
import {
  selectDraftType,
  selectShowCannedModal,
  selectIsForwarding,
} from 'selectors/page'
import {
  selectIsTwitterTicket,
  selectIsFacebookTicket,
} from 'selectors/tickets'
import { selectDraftIdByTicketId } from 'ducks/drafts2/selectors'
import { selectShouldUseDraftsV2 } from 'selectors/app'
import ReplyForm from './view'

const select = () => {
  return (state, props) => {
    const { ticketId } = props
    const usesDraftsV2 = selectShouldUseDraftsV2(state)
    const isTwitterTicket = selectIsTwitterTicket(state)
    const isFacebookTicket = selectIsFacebookTicket(state)

    if (!isFacebookTicket && !isTwitterTicket && usesDraftsV2) {
      return {
        draftId: selectDraftIdByTicketId(state, ticketId),
        usesDraftsV2,
        isAgentColliding: selectIsAgentColliding(state, ticketId),
        isFacebookTicket: selectIsFacebookTicket(state),
        isTwitterTicket: selectIsTwitterTicket(state),
        showingCanned: selectShowCannedModal(state),
      }
    }
    return {
      draft: selectReplyDraft(state),
      draftId: selectDraftIdByTicketId(state, ticketId),
      draftType: selectDraftType(state),
      usesDraftsV2: selectShouldUseDraftsV2(state),
      isAgentColliding: selectIsAgentColliding(state, ticketId),
      isDraftSendable: selectTicketDraftIsSendable(state),
      isFacebookTicket: selectIsFacebookTicket(state),
      isTwitterTicket: selectIsTwitterTicket(state),
      showingCanned: selectShowCannedModal(state),
      isForwarding: selectIsForwarding(state),
    }
  }
}

const perform = dispatch => {
  return {
    ...bindActionCreators(
      {
        doOpenTicketPage,
        doRealtimeAgentStartTicketTypingNotification,
        doInitializeDraft,
      },
      dispatch
    ),
    // bindActionCreators not playing well with our curried action creators
    ...{
      updateDraft: (ticketId, prop, val) =>
        dispatch(doUpdateReplyDraft(ticketId, prop, val)),
      updateDraftDelayed: (ticketId, prop, val) =>
        dispatch(doUpdateReplyDraftDelayed(ticketId, prop, val)),
      updateAndSendDraft: (ticketId, prop, val) =>
        dispatch(doUpdateAndSendReplyDraft(ticketId, prop, val)),
    },
  }
}

const LoadingPlaceholder = styled('div')`
  height: 100px;
`

export default withDeferedRender(
  connect(select, perform)(ReplyForm),
  LoadingPlaceholder
)
